import App from "./App";
import PathProvider from "./libs/path/PathProvider";
import "./scss/index.scss"

import ReactDOM from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import FManApi from "./fmanlibs/FManApi";
import Dirs from "./fmanlibs/Dirs";
import Files from "./fmanlibs/Files";
import { IUser } from "./libs/login/JWTApi";
import SnackbarProvider from "./gui/Snackbar/SnackbarProvider";
import OverlayProvider from "./gui/Overlay/OverlayProvider";
import AuthProvider from "./gui/Login/AuthProvider";
import LoginProvider from "./gui/Login/LoginProvider";

(async () => {
    const root = ReactDOM.createRoot(document.getElementById("root")!)
    await FManApi.i.init().auth()

    const onAuth = async (user:IUser) => {
        await Dirs.i.expire().get();        
        const home = (await Dirs.i.root).getChildByName("Home")
        if (home) Files.i.expire(home._id).get(home._id)
    }
    root.render(
    <AuthProvider api={FManApi.i}>
        <PathProvider><SnackbarProvider><OverlayProvider><LoginProvider api={FManApi.i} onAuth={onAuth}>
            <App/>  
    </LoginProvider></OverlayProvider></SnackbarProvider></PathProvider>
    </AuthProvider>)

    serviceWorkerRegistration.register()
})()